import React from 'react';
import './BookipixLoader.css';

// Attente de l'atelier : deux billes aux couleurs de Bookipix (bleu et jaune) qui se rencontrent, s'entrechoquent
// dans une petite etincelle, puis repartent — en boucle. Remplace les textes « Chargement de l'atelier… » /
// « Chargement de la page… ». Aucun texte visible : un libelle accessible seulement (lecteurs d'ecran).
// `size` : 'lg' (atelier qui s'ouvre, plein ecran) ou 'md' (page qui se charge sur le livre).
function BookipixLoader({ size = 'md', label = 'Chargement' }) {
  return (
    <span className={`bpx-loader is-${size}`} role="status" aria-label={label}>
      <span className="bpx-spark" aria-hidden="true" />
      <span className="bpx-ball is-blue" aria-hidden="true" />
      <span className="bpx-ball is-yellow" aria-hidden="true" />
    </span>
  );
}

export default BookipixLoader;
